function GlobalEventBus() {

    const allHandlers = new Map();

    return {

        on(type: string, handler: (...args: any) => void, replaceHandler: boolean = true) {
            let handlers = allHandlers.get(type);

            if (!handlers || replaceHandler) {
                handlers = [handler];
            } else {
                handlers.push(handler);
            }

            allHandlers.set(type, handlers);
        },

        off(type: string, handler?: () => void) {

            const handlers = allHandlers.get(type);

            if (handlers) {

                if (handler) {
                    handlers.splice(handlers.indexOf(handler) >>> 0, 1);
                } else {
                    allHandlers.delete(type)
                }

            }
        },

        emit(type: string, ...params: any) {
            const handlers = allHandlers.get(type);

            if (handlers) {
                handlers.slice().map((handler) => {
                    handler(...params);
                });
            }
        }
    };

}

export const enum EventsList {
    ReloadActiveTablePage = 'ReloadActiveTablePage',
    ChangeTheme = 'ChangeTheme',
}

export default GlobalEventBus();